import styled from 'styled-components';

export const Container = styled.div`
  .radio-button {
    cursor: pointer;
  }

  input[type=radio] {
      box-sizing: border-box;
      padding: 0;
  }

  input {
      outline: 0;
      background-color: transparent;
  }

  .radio-button-input {
      opacity: 0;
      position: absolute;
  }

  .radio-button-control {
    width: 11px;
    height: 11px;
    border-radius: 11px;
    border: 1px solid ${(props) => props.theme.colors.radioButtonColor};
    background: inherit;
    vertical-align: middle;
    display: inline-block;
    margin-right: 7px;
    margin-bottom: 2px;

    &.dark{
      border: 1px solid #ccc;
      background: #ccc;
    }
  }

  .radio-button-input:checked+.radio-button-control:after {
    content: "";
    display: block;
    top: 0px;
    left: 0px;
    width: 11px;
    height: 11px;
    border-radius: 11px;
    background-color: #00C6C9;
  }

  .radio-button-input:checked+.radio-button-control {
      border: 0;
  }

`;
